export default "__VITE_ASSET__BicZDCYV__"